import { getDisplayFromCodableConcepts } from '@quromedical/fhir-common';
import type {
  External,
  QualificationFields,
  Settings,
} from '@quromedical/models';
import { FormCard, type RowConfig } from 'design-system';
import { strings } from 'strings';

interface QualificationCardProps {
  data?: Partial<QualificationFields>;
  canEdit: boolean;
  onEditPress: () => void;
}

interface ExternalCardProps {
  data?: Partial<External>;
  canEdit: boolean;
  onEditPress: () => void;
}

interface SettingsCardProps {
  data?: Partial<Settings>;
  canEdit: boolean;
  onEditPress: () => void;
}
const getPractitionerQualificationRows = (
  practitioner: Partial<QualificationFields> = {},
): RowConfig[] => [
  {
    icon: 'school',
    fields: [
      {
        type: 'text',
        label: strings.Specialty,
        display: practitioner.qualificationCode
          ? getDisplayFromCodableConcepts([practitioner.qualificationCode.code])
          : undefined,
      },
    ],
  },

  {
    fields: [
      {
        type: 'text',
        label: strings.RegistrationNumber,
        display: practitioner.registrationNumber,
      },
    ],
  },
];

const getExternalRows = (practitioner: Partial<External> = {}): RowConfig[] => [
  {
    icon: 'science',
    fields: [
      {
        type: 'text',
        label: strings.AmpathMnemonic,
        display: practitioner.ampathMnemonic,
      },
    ],
  },
];

const getPractitionerSettingsRows = (
  practitioner: Partial<Settings> = {},
): RowConfig[] => [
  {
    icon: 'description',
    fields: [
      {
        type: 'text',
        label: strings.FormLabelPractitionerCanPrescribe,
        display: practitioner.canPrescribe ? 'Yes' : 'No',
      },
    ],
  },
];

export const QualificationCard: React.FC<QualificationCardProps> = ({
  data,
  canEdit,
  onEditPress,
}) => (
  <FormCard
    isButtonVisible={canEdit}
    onButtonPress={onEditPress}
    buttonText={strings.ButtonTextEdit}
    buttonIcon="edit"
    showIcons
    title={strings.FormLabelPractitionerQualificationDetails}
    rows={getPractitionerQualificationRows(data)}
  />
);

export const ExternalCard: React.FC<ExternalCardProps> = ({
  data,
  canEdit,
  onEditPress,
}) => (
  <FormCard
    isButtonVisible={canEdit}
    onButtonPress={onEditPress}
    buttonText={strings.ButtonTextEdit}
    buttonIcon="edit"
    showIcons
    title={strings.FormLabelPractitionerExternal}
    rows={getExternalRows(data)}
  />
);

export const SettingsCard: React.FC<SettingsCardProps> = ({
  data,
  canEdit,
  onEditPress,
}) => (
  <FormCard
    isButtonVisible={canEdit}
    onButtonPress={onEditPress}
    buttonText={strings.ButtonTextEdit}
    buttonIcon="edit"
    showIcons
    title={strings.FormLabelPractitionerCanPrescribeSettings}
    rows={getPractitionerSettingsRows(data)}
  />
);
